import { useEffect } from "react";

export function useDocumentListener(event: string, callback: (event: Event) => void) {
  useEffect(() => {
    document.addEventListener(event, callback);
    return () => document.removeEventListener(event, callback);
  }, [event, callback]);
}
